import { render, staticRenderFns } from "./waterelall.vue?vue&type=template&id=57b000fa&scoped=true&"
import script from "./waterelall.vue?vue&type=script&lang=js&"
export * from "./waterelall.vue?vue&type=script&lang=js&"
import style0 from "./waterelall.vue?vue&type=style&index=0&id=57b000fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b000fa",
  null
  
)

export default component.exports